export default __webpack_public_path__ + "2c4911690c724c66e36fbaa000e8e15f.jpg";